import type { SharedPreset, SharedPresetUser } from './api/types';

/** Поля элемента списка пресетов, которые совместный пресет таблицы и совместный дашборд берут из ответа одинаково */
export type SharedPresetListFields = {
  name: string;
  /** Закреплён в левом меню у текущего пользователя */
  pinned: boolean;
  isShared: true;
  owner: SharedPresetUser;
  /** Получатели — известны только владельцу */
  recipients?: SharedPresetUser[];
  /** Текущий пользователь вправе править пресет — он его владелец */
  isEditable: boolean;
};

/** Переводит совместный пресет из ответа сервера в общие поля элемента списка пресетов. */
export const toSharedPresetListFields = (preset: SharedPreset<unknown>): SharedPresetListFields => ({
  name: preset.name,
  pinned: preset.isPinned,
  isShared: true,
  owner: preset.owner,
  recipients: preset.isOwner ? preset.recipients : undefined,
  isEditable: preset.isOwner,
});
